var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCommentBlue = function SvgIconCommentBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-comment",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 12 12"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "chat",
    transform: "translate(-415.411 -85.103)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "chat-2",
    "data-name": "chat",
    d: "M422.911 85.1h-3a4.5 4.5 0 0 0-1 8.885V97.1l3.5-3h.5a4.5 4.5 0 0 0 0-9Z",
    fill: "#1eaae1"
  }))));
};
export { SvgIconCommentBlue as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyBpZD0iaWNvbi1jb21tZW50IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDEyIDEyIj4KICA8cmVjdCBpZD0iUmVjdGFuZ2xlXzIwIiBkYXRhLW5hbWU9IlJlY3RhbmdsZSAyMCIgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwKSIgZmlsbD0iI2ZmZiIgb3BhY2l0eT0iMCIvPgogIDxnIGlkPSJjaGF0IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNDE1LjQxMSAtODUuMTAzKSI+CiAgICA8cGF0aCBpZD0iY2hhdC0yIiBkYXRhLW5hbWU9ImNoYXQiIGQ9Ik00MjIuOTExLDg1LjFoLTNhNC41LDQuNSwwLDAsMC0xLDguODg1Vjk3LjFsMy41LTNoLjVhNC41LDQuNSwwLDAsMCwwLTlaIiBmaWxsPSIjMWVhYWUxIi8+CiAgPC9nPgo8L3N2Zz4K";